import gsap from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import Curtain from "./Curtain";

export default class Preloader {
    _container;

    static init() {
        this._container = GetBy.id('Preloader');
    }

    static update(__progress) { }

    static hide(__call) {
        // if (isDebug) {
        //     this._container.style.display = "none";
        //     Curtain.hide(__call);
        //     return;
        // }

        gsap.to(this._container, {
            duration: .3,
            opacity: 0,
            delay: .5,
            onComplete: () => {
                this._container.style.display = "none";
                Curtain.hide(__call);
            }
        });
    }
}
